export default __webpack_public_path__ + "static/media/seal.d6b2d21e.svg";